
export function capitalizeFirstLetter(value: string): string {
  if (!value) return value;
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

export function capitalize(str: string){
    const words = str.split(' ');
    const smallWords = ['de', 'da', 'do', 'das', 'dos', 'e', 'a', 'o', 'as', 'os'];
    const wordsCap = words.map((word, index) => {
        // Sempre capitaliza a primeira palavra
        if (index === 0) {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }
        // Mantém palavras pequenas/preposições em minúsculas
        if (smallWords.includes(word.toLowerCase())) {
            return word.toLowerCase();
        }
        // Capitaliza as outras palavras
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    return wordsCap.join(' ');
}

export function truncateText(text: string, delimiter = 10, stringConcat = '...') {
    if (!text) return null;
    if (text.length >= delimiter) {
        return text.slice(0, delimiter).concat(stringConcat);
    }
    return text;
}

export function toSnakeCase(text) {
    return text.split('').map((character) => {
        if (character == character.toUpperCase()) {
            return '_' + character.toLowerCase();
        } else {
            return character;
        }
    })
        .join('');
}


export function splitCamelCase(text){
    return text.replace(/([A-Z])/g, ' $1')
}

export function getOnlyNumbersInString(text: string) {
    if (!text) return '';
    return text.replace(/[^0-9]/g, '');
}


export function toCamelCase(str: string) {
    if (!str) return '';
    return str.toLowerCase()
        .replace(/([-_][a-z])/g, (group) => {
            return group
                .toUpperCase()
                .replace('-', '')
                .replace('_', '')
        });
}

export function hifenToUnderline(str: string) {
    if (!str) return '';
    return str.replace(/([-_/][a-z])/g, (group) => {
        return group
            .replace('/', '_')
            .replace('-', '_')
    });
}

export function stringToPhoneMask(text: string) {
    if (!text) return '';
    if(text.length == 11){
        const phone = text.match(/(\d{2})(\d{5})(\d{4})/)
        if(phone) return `(${phone[1]}) ${phone[2]}-${phone[3]}`
    }else{
        const phone = text.match(/(\d{2})(\d{4})(\d{4})/)
        if(phone) return `(${phone[1]}) ${phone[2]}-${phone[3]}`
    }

}

    
export function generateCSVFileName(reportName: string, translate: (key: string) => string) {
    const now = new Date()
    const date = now.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).replace(/\//g, '-')

    const time = now.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
    }).replace(':', 'h')

    return `${translate(reportName)} - ${date},${time}.csv`
}
